import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import type { Actions } from '../constants/actionTypes';
import { mainHandler } from '../redux/reducers/mainHandler';

type TLegacyDispatchOptions = {
  type: Actions;
  payload: any;
};

export const useMainDispatch = () => {
  const dispatch = useDispatch();

  // * Legacy dispatch for calling with { type: Action, payload }
  // * ideally we would want to call the action directly (toolkit method) like below
  const legacyDispatch = useCallback(
    (options: TLegacyDispatchOptions) => {
      const { type, payload } = options;
      const handler = mainHandler[type];
      return dispatch(handler(payload as never));
    },
    [dispatch],
  );

  return legacyDispatch;
};
